import { render, staticRenderFns } from "./extraDetails.vue?vue&type=template&id=5d4debf3"
import script from "./extraDetails.vue?vue&type=script&lang=js"
export * from "./extraDetails.vue?vue&type=script&lang=js"
import style0 from "./extraDetails.vue?vue&type=style&index=0&id=5d4debf3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports